'use strict';

var buildEnhancedMapping = require('../internal/buildEnhancedMapping');

module.exports = buildEnhancedMapping('map');


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/enumerable/var/enhancedMap.js
// module id = 802
// module chunks = 0